import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../../become-a-customer-feature.selector';

export const getAffiliatePromoCodeState = createSelector(
  getBecomeACustomerState,
  (state) => state?.affiliatePromoCode
);

export const getPromoCodeId = createSelector(
  getAffiliatePromoCodeState,
  (state) => state?.promoCodeId
);

export const getPromoCodePlans = createSelector(
  getAffiliatePromoCodeState,
  (state) => state?.promoCodePlans
);

export const getPromoCodeFormState = createSelector(
  getAffiliatePromoCodeState,
  (state) => state?.formState
);
